import { createAction } from "@reduxjs/toolkit"
import { IGetMealPlanSuggestionEligibiltyResponse } from "../interfaces/api/ambrosia/getMealPlanSuggestionEligibility"
import { IGet8pMealPlanSuggestionsResponse, IProtocolMealPlanSuggestion } from "../interfaces/api/ambrosia/get8pMealPlanSuggestions"
import { IMealComponent } from "../interfaces/api/ambrosia/IMealOption"
import { ICleansingPlansProtocolData } from "../interfaces/mealPlanProtocol/IMealPlanProtocol"

export enum MealPlanProtocolActionNames {
	SET_MEAL_PLAN_PROTOCOL = "SET_MEAL_PLAN_PROTOCOL",
	SET_PROTOCOL_MEAL_PLAN_SUGGESTIONS = "SET_PROTOCOL_MEAL_PLAN_SUGGESTIONS",
	SET_SUGGESTED_DISH_DETAILS_MAP = "SET_SUGGESTED_DISH_DETAILS_MAP",
	SET_CLEANSING_PLANS_PROTOCOL_DATA = "SET_CLEANSING_PLANS_PROTOCOL_DATA",
}

export const setMealPlanProtocol = createAction<IGetMealPlanSuggestionEligibiltyResponse>(MealPlanProtocolActionNames.SET_MEAL_PLAN_PROTOCOL)
export const setProtocolMealSuggestions = createAction<Record<string, IProtocolMealPlanSuggestion>>(MealPlanProtocolActionNames.SET_PROTOCOL_MEAL_PLAN_SUGGESTIONS)
export const setSuggestedDishDetailsMap = createAction<Record<string, IMealComponent>>(MealPlanProtocolActionNames.SET_SUGGESTED_DISH_DETAILS_MAP)
export const setCleansingPlansProtocolData = createAction<ICleansingPlansProtocolData>(MealPlanProtocolActionNames.SET_CLEANSING_PLANS_PROTOCOL_DATA)
